import React from "react";
import { Box, InputAdornment, InputBase } from "@mui/material";
import CloseIcon from "@iconify/icons-mdi/close";
import { InlineIcon } from "@iconify/react";

interface OcDataTableHeaderSearchFormProps {
  id: string;
  onSearchChange: (params: { searchField: string; searchText: string }) => void;
  searchText: string;
  searchField: string;
}

export const OcDataTableHeaderSearchForm: React.FC<
  OcDataTableHeaderSearchFormProps
> = ({ id, onSearchChange, searchText, searchField }) => {
  if (searchField !== id) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange({ searchField: id, searchText: e.target.value });
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape") {
      onSearchChange({ searchField: "", searchText: "" });
    }
  };

  return (
    <Box
      id="search-form"
      position="absolute"
      height="48px"
      top="4px"
      left="0px"
      display="flex"
      flexDirection="row"
      justifyContent="strech"
      alignItems="center"
      flexGrow={1}
      width="100%"
    >
      <InputBase
        value={searchText}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        autoFocus={true}
        endAdornment={
          <InputAdornment position="end">
            <InlineIcon
              icon={CloseIcon}
              onClick={() =>
                onSearchChange({ searchField: "", searchText: "" })
              }
              style={{ cursor: "pointer" }}
            />
          </InputAdornment>
        }
        style={{
          backgroundColor: "white",
          height: "32px",
          paddingLeft: "16px",
          paddingRight: "16px",
          borderRadius: "4px",
          margin: "0px 8px",
          width: "100%",
        }}
      />
    </Box>
  );
};

export default OcDataTableHeaderSearchForm;
